import { Component, inject } from '@angular/core';
import {
  ChunkProgressBarComponent,
} from "@progress/kendo-angular-progressbar";
import { NgClass, NgOptimizedImage } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { StepsService } from 'src/app/services/steps.service';
import { Icons } from "src/app/icons";
import { SpacerComponent } from "src/app/ui/atoms/spacer/spacer.component";

@Component({
    selector: 'app-header',
    imports: [
        TranslatePipe,
        NgOptimizedImage,
        ChunkProgressBarComponent,
        SpacerComponent,
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  protected s = inject(StepsService);
  protected readonly icons = Icons;
}
